import { Component } from '@angular/core'

@Component({
    template: `<div class="rect-ghost-loading"></div>`,
    styleUrls: ['./rect-ghost-loading.component.scss'],
    standalone: true

})
export class RectGhostLoadingComponent { }
